import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_CITY, EDIT_CITY, CREATE_CITY } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteCity(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_CITY}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editCity(prevData, searchParams, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_CITY}`, {
    id: prevData?.id,
    title: prevData?.title,
    provinceId: searchParams.get("stateId")
  }, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createCity(prevData, searchParams, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_CITY}`, {
    title: prevData?.title,
    provinceId: searchParams.get("stateId")
  }, configReq(token));
}
